import { SHORTCUT_YIELD, useRegisterShortcut, } from '#pplx/frontend/apps/ask/keyboard-shortcuts-provider/registry.js';
import { SearchMode } from '#pplx/frontend/ask-models/types/search-modes.js';
import { useCallback } from 'react';
export function useHomeModeShortcuts({ enabled, searchEnabled, onSearchModeSelect, }) {
    const handleSearchShortcut = useCallback((event) => {
        if (event.isComposing || event.repeat || !onSearchModeSelect)
            return SHORTCUT_YIELD;
        // Prevent the browser from also handling the consumed Home shortcut after selecting Search.
        event.preventDefault();
        onSearchModeSelect(SearchMode.SEARCH);
        return undefined;
    }, [onSearchModeSelect]);
    const handleComputerShortcut = useCallback((event) => {
        if (event.isComposing || event.repeat || !onSearchModeSelect)
            return SHORTCUT_YIELD;
        // Prevent the browser from also handling the consumed Home shortcut after selecting Computer.
        event.preventDefault();
        onSearchModeSelect(SearchMode.ASI);
        return undefined;
    }, [onSearchModeSelect]);
    useRegisterShortcut({
        id: 'home-search-mode',
        handler: handleSearchShortcut,
        isEnabled: enabled && searchEnabled && onSearchModeSelect !== undefined,
        isAvailable: searchEnabled,
    });
    useRegisterShortcut({
        id: 'home-computer-mode',
        handler: handleComputerShortcut,
        isEnabled: enabled && onSearchModeSelect !== undefined,
    });
}
//# sourceMappingURL=useHomeModeShortcuts.js.map